import template from './kndef-krepre-list.html';

export default {
	template,
	bindings: {
		list:    '<ngModel',
	},
};
